import axios from "axios";

// Connect DIRECTLY to the production Pit Link backend.
// Either REACT_APP_API_URL or REACT_APP_BACKEND_URL can point at it — both
// are set to the prod host in .env so writes reach the real backend.
export const API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_BACKEND_URL ||
  "https://field-maint.emergent.host";
export const API = `${API_BASE}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true, // send httpOnly session cookies if backend sets them
});

// If the login endpoint returns a token (JWT) in the JSON body, we store it
// and forward it as a Bearer header for later requests too.
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;

  // Pit Link is strictly site-scoped. Every request carries the active site
  // via X-Site-Override so the backend returns only that site's data.
  const site = localStorage.getItem("sl_active_site");
  if (site) config.headers["X-Site-Override"] = site;

  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 || err.response?.status === 403) {
      const path = window.location.pathname;
      // Only redirect on 401 from a protected route, not the login page itself
      if (err.response?.status === 401 && path !== "/login") {
        localStorage.removeItem("sl_token");
        localStorage.removeItem("sl_user");
        // Soft-redirect: only send to /login if we clearly lost the session
        if (!err.config?.url?.includes("/auth/me")) {
          window.location.href = "/login";
        }
      }
    }
    return Promise.reject(err);
  }
);

export function apiError(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) {
    return d
      .map((x) => x.msg || (typeof x === "string" ? x : JSON.stringify(x)))
      .join(" · ");
  }
  if (typeof d === "object" && d.msg) return d.msg;
  return String(d);
}
